import React from 'react'

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  Button,
  StatusDot,
  ContentBlock,
  Card,
  Icon,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";
import { Switch, Route, Link } from "react-router-dom";


export default function PAlauncherNew({handleModal = ()=>void(0)}) {
  return (
    <div>
            <div className="xsui-modal xsui-modal--size-md">
              <div className="xsui-modal__overlay" />
              <div className="xsui-modal__entry">
                <div
                  className="xsui-modal__close"
                  data-id="close_modal"
                  onClick={() => handleModal()}
                />
                <div className="xsui-content-block xsui-content-block--appearance-modal">
                  <div className="xsui-content-block__entry xsui-head--align-center xsui-head--indentation-xs">
                    {/* <form> */}
                    <div className="xsui-head xsui-head--appearance-primary  xsui-head--indentation-lg">
                      <div className="xsui-head__title">New Launcher</div>


                    </div>
                  </div>

                  <FormGroup indentation="lg">

                  <Link to="/launcher/my_project">
                    <Button>Create launcher</Button>
                    </Link>

                  </FormGroup>


                  </div>
              </div>
            </div>
    </div>
  )
}
